import React, { Fragment, useState, useEffect, useContext } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import Contactbox from "./Contactbox";
import AddContact from "./AddContact";
import ReactPaginate from "react-paginate";
import { useTranslation, withTranslation } from "react-i18next";

const compte = localStorage.getItem("compte");
const poste = localStorage.getItem("poste");
const token = localStorage.getItem("AccessToken");
const BackendURL = window.BackendURLCmk;

function Contact() {
  const { t } = useTranslation("common");

  const [croix, setcroix] = useState(false);

  //const [collegues, setCollegue] = useState([]);
  const [colleguesPerPage] = useState(50);
  const [offset, setOffset] = useState(1);
  const [collegues, setAllcollegues] = useState([]);
  const [collegues2, setAllcollegues2] = useState([]);

  const [pageCount, setPageCount] = useState(0);
  const [showModal, setShow] = useState(false);

  const handleClose = () => setShow(false);
  const handleShow = () => setShow(true);

  const [loading, setloading] = useState("false");

  const [collguesforpagination, setPageCollegues] = useState([]);
  const length = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {offset * colleguesPerPage}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };
  const length2 = () => {
    return (
      <div className="flex">
        {1 + (offset - 1) * colleguesPerPage} - {collguesforpagination.length}{" "}
        {t("sur")}
        <div className="ml-2 -mt-1 text-2xl font-bold ">
          {collguesforpagination.length}
        </div>
      </div>
    );
  };

  let countforpagination =
    1 +
    (offset - 1) * colleguesPerPage +
    " - " +
    offset * colleguesPerPage +
    "  sur  " +
    collguesforpagination.length;

  const getPostData = (data) => {
    return data.map((post, i) => (
      <Contactbox contact={post} key={i} toggle={getAllcollegues} />
    ));
  };
  let countforpagination2 =
    1 +
    (offset - 1) * colleguesPerPage +
    " - " +
    collguesforpagination.length +
    "  sur  " +
    collguesforpagination.length;

  const getAllcollegues = async () => {
    setloading(true);
    var lien = window.location.href;
    //console.log(lien);
    const var2 = lien.split("/");
    //console.log("kien ici", var2[2]);
    var var4 = var2[2].split(":");

    var config = {
      headers: {
        Authorization: token,
      },
    };

    const result = await axios
      .get(
        `https://${BackendURL}:4444/${window.switchAPI}/Api/WS/CarnetAdresseIPBXV3API?compte=${compte}&poste=${poste}`,
        config //, requestOptions
      )
      .then((res) => {
        setloading(false);
        setAllcollegues2(res.data.carnet_adresse);
        const data = res.data.carnet_adresse;
        localStorage.setItem("tabcontact", JSON.stringify(data));

        setPageCollegues(data);

        const slice = data.slice(
          (offset - 1) * colleguesPerPage,
          offset * colleguesPerPage
        );
        //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
        // console.log(slice);

        // For displaying Data
        const postData = getPostData(slice);

        // Using Hooks to set value
        setAllcollegues(postData);
        setPageCount(Math.ceil(data.length / colleguesPerPage));
      })
      .catch((err) => {
        if (err == "Error: Request failed with status code 401") {
          localStorage.clear();
          var link = "/";

          window.location.replace(link);
        } else {
          console.log("AXIOS ERROR: ", err);
        }
      });
  };
  const handlePageClick = (event) => {
    // console.log("here the selcted event", event);
    const selectedPage = event.selected;
    setOffset(selectedPage + 1);
  };

  useEffect(() => {
    getAllcollegues();
  }, [offset]);
  function test() {
    setSearchText("");
    getAllcollegues();
    // console.log("heeeeeeeeeey", searchText);

    setcroix(true);
  }
  const upper = (nom) => {
    return nom.toUpperCase();
  };

  const [searchText, setSearchText] = useState("");

  const filterData = (value) => {
    const lowercasedValue = value.toLowerCase().trim();
    if (lowercasedValue === "") getAllcollegues();
    else {
      //console.log(collegues2);
      const filteredData = collegues2.filter((item) => {
        return Object.keys(item).some((key) =>
          item[key].toString().toLowerCase().includes(lowercasedValue)
        );
      });
      // setAllcollegues(filteredData);
      //  console.log("this is value", filteredData);
      setPageCollegues(filteredData);
      setOffset(1);
      const slice = filteredData.slice(
        (offset - 1) * colleguesPerPage,
        offset * colleguesPerPage
      );
      //array.slice((offset - 1) * colleguesPerPage, offset * colleguesPerPage)
      // console.log(slice);

      // For displaying Data
      const postData = getPostData(slice);

      // Using Hooks to set value
      setAllcollegues(postData);
      setPageCount(Math.ceil(filteredData.length / colleguesPerPage));
      //getPostData(filteredData);
    }
  };

  const handleChange = (value) => {
    //console.log("this is value of research ", value);
    setSearchText(value);
    filterData(value);
  };
  if (loading == false) {
    return (
      <div className="content pb-4 flex flex-col h-screen">
        {/* {console.log(collegues)} */}
        <div className="py-2">
          <div class="md:flex md:items-center md:justify-between ">
            <div class="flex-1 min-w-1">
              <h2 className="dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                Contacts
                {/* <span className="text-gray-600 text-sm rounded-xl bg-gray-100 ml-2 -mt-16 px-2 py-1">
                  <span>{collguesforpagination.length}</span>
                </span> */}
              </h2>
            </div>

            <div class="flex space-x-3 md:absolute md:top-3 md:right-2 mt-4 mb-4 mr-8">
              <div class="ml-2 mt-1 relative rounded-md shadow-sm">
                <input
                  type="text"
                  className="dark:bg-gray-600 dark:text-gray-300 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                  placeholder={t("touvercontact")}
                  value={searchText}
                  onChange={(e) => handleChange(e.target.value)}
                  style={{
                    webKitBoxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                    boxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  }}
                />{" "}
                <div class="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-400 dark:text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
                {searchText != "" ? (
                  <button
                    type="button"
                    className="absolute inset-y-0 right-0 pr-3 pl-3 flex items-center dark:text-gray-100 transition-al hover:bg-gray-100"
                    onClick={() => {
                      test();
                    }}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="h-5 w-5 text-gray-400"
                      fill="none"
                      viewBox="0 0 24 24"
                      stroke="currentColor"
                    >
                      <path
                        stroke-linecap="round"
                        stroke-linejoin="round"
                        stroke-width="2"
                        d="M6 18L18 6M6 6l12 12"
                      />
                    </svg>
                  </button>
                ) : (
                  <div></div>
                )}
              </div>

              <span class="shadow-xs rounded-md mr-8 mt-2 hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                <button
                  type="button"
                  onClick={handleShow}
                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:shadow-outline-green focus:border-green-600 active:bg-green-600 transition duration-150 ease-in-out"
                  style={{
                    webKitBoxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                    boxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  }}
                >
                  <svg
                    class="-ml-1 mr-2 h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>{t("newcontact")}</span>
                </button>{" "}
              </span>
              <span class="shadow-xs rounded-md mr-8 mt-2 lg:hidden md:hidden">
                {" "}
                <button
                  type="button"
                  onClick={handleShow}
                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:shadow-outline-green focus:border-green-600 active:bg-green-600 transition duration-150 ease-in-out"
                  style={{
                    webKitBoxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                    boxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 dark:text-gray-300 "
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                  </svg>
                </button>
              </span>

              <AddContact
                showModal={showModal}
                handleClose={handleClose}
                toggle={getAllcollegues}
              />
            </div>
            {collguesforpagination.length !== 0 ? (
              <div className="flex mt-8 mb-8 lg:mt-28 md:mt-28">
                <div
                  className="flex"
                  style={{ marginLeft: "auto", order: "2" }}
                >
                  <span
                    className="text-gray-500 dark:text-white"
                    //  style={{ marginLeft: "auto", order: "2" }}
                  >
                    {offset == pageCount ? length2() : length()}
                  </span>

                  <ReactPaginate
                    previousLabel={"<"}
                    previousClassName={
                      "p-0.5 md:p-1.5 lg:p-1.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center  border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    }
                    nextLabel={">"}
                    nextClassName={
                      "pl-1.5 lg:pl-2.5 md:pl-2.5 dark:text-white dark:hover:bg-gray-600 ml-2 -mt-1 h-8 w-8 inline-flex items-center p-1.5 border border-transparent rounded-full  text-gray-500 hover:bg-gray-100 hover:text-green-600  focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-600"
                    }
                    breakLabel={"countforpagination"}
                    breakClassName={"hidden"}
                    pageClassName={
                      "hidden relative inline-flex items-center px-4 py-2 border border-gray-300 bg-white text-sm font-medium text-gray-700 hover:bg-gray-50"
                    }
                    pageCount={pageCount}
                    onPageChange={handlePageClick}
                    containerClassName={
                      "relative z-0 inline-flex rounded-md  -space-x-px"
                    }
                    activeClassName=""
                    forcePage={offset - 2}
                  />
                </div>
              </div>
            ) : (
              <div></div>
            )}
          </div>
        </div>
        {collguesforpagination.length !== 0 ? (
          <div className="dark:bg-gray-900 overflow-y-auto">
            <div className="dark:bg-gray-900">
              <div className="dark:bg-gray-900 align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table className="dark:bg-gray-900 min-w-full">
                  <thead>
                    <tr>
                      <th className="dark:bg-gray-600 dark:text-white w-12 px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        &nbsp;
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("Nom.contact.table")}
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("Prenom.contact.table")}
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("tel.contact.table")}
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("adress.contact.table")}
                      </th>

                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">{collegues}</tbody>
                </table>
              </div>
            </div>
          </div>
        ) : (
          <div className="justify-center mt-64  p-0 self-center">
            <h2 className="  dark:text-white text-lg font-medium leading-7  sm:text-3xl sm:truncate text-gray-400">
              {t("nocontact")}
            </h2>
          </div>
        )}
      </div>
    );
  } else {
    return (
      <div className="content pb-4">
        {/* {console.log(collegues)} */}
        <div className="py-2">
          <div class="flex space-x-3 md:absolute md:top-3 md:right-2 mt-4 mb-4 mr-8">
            <div class="md:flex md:items-center md:justify-between ">
              <div class="flex-1 min-w-1">
                <h2 className="dark:text-white text-2xl font-bold leading-7 text-gray-900 sm:text-3xl px-4 py-4 sm:truncate">
                  Contacts
                  {/* <span className="text-gray-600 text-sm rounded-xl bg-gray-100 ml-2 -mt-16 px-2 py-1">
                  <span>{collguesforpagination.length}</span>
                </span> */}
                </h2>
              </div>
              <div class="ml-2mt-1 relative rounded-md shadow-sm">
                <input
                  type="text"
                  className="dark:bg-gray-600 dark:text-gray-300 focus:border-transparent focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-green-300 border-grey-100 rounded-md border block w-full py-3 pr-12 pl-12"
                  placeholder={t("touvercontact")}
                  value={searchText}
                  onChange={(e) => handleChange(e.target.value)}
                  style={{
                    webKitBoxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                    boxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  }}
                />{" "}
                <div class="dark:text-white absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                  <svg
                    className="h-5 w-5 text-gray-400 dark:text-white"
                    xmlns="http://www.w3.org/2000/svg"
                    fill="none"
                    viewBox="0 0 24 24"
                    stroke="currentColor"
                  >
                    <path
                      strokeLinecap="round"
                      strokeLinejoin="round"
                      strokeWidth="2"
                      d="M21 21l-6-6m2-5a7 7 0 11-14 0 7 7 0 0114 0z"
                    />
                  </svg>
                </div>
              </div>

              <span class="shadow-xs rounded-md mr-8 mt-2 hidden lg:flex lg:flex-shrink-0 md:flex md:flex-shrink-0">
                <button
                  type="button"
                  onClick={handleShow}
                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:shadow-outline-green focus:border-green-600 active:bg-green-600 transition duration-150 ease-in-out"
                  style={{
                    webKitBoxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                    boxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  }}
                >
                  <svg
                    class="-ml-1 mr-2 h-5 w-5"
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path
                      fillRule="evenodd"
                      d="M10 3a1 1 0 011 1v5h5a1 1 0 110 2h-5v5a1 1 0 11-2 0v-5H4a1 1 0 110-2h5V4a1 1 0 011-1z"
                      clipRule="evenodd"
                    ></path>
                  </svg>
                  <span>{t("newcontact")}</span>
                </button>{" "}
              </span>
              <span class="shadow-xs rounded-md mr-8 mt-2 lg:hidden md:hidden">
                {" "}
                <button
                  type="button"
                  onClick={handleShow}
                  class="relative inline-flex items-center px-4 py-2 border border-transparent text-sm leading-5 font-medium rounded-md text-white bg-green-600 hover:bg-green-700 focus:outline-none focus:shadow-outline-green focus:border-green-600 active:bg-green-600 transition duration-150 ease-in-out"
                  style={{
                    webKitBoxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                    boxShadow:
                      " 0 4px 4px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 2px 2px 0 rgb(50 50 50 / 8%), 0 0 1px 0 rgb(50 50 50 / 30%)",
                  }}
                >
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    class="h-6 w-6 dark:text-gray-300 "
                    viewBox="0 0 20 20"
                    fill="currentColor"
                  >
                    <path d="M8 9a3 3 0 100-6 3 3 0 000 6zM8 11a6 6 0 016 6H2a6 6 0 016-6zM16 7a1 1 0 10-2 0v1h-1a1 1 0 100 2h1v1a1 1 0 102 0v-1h1a1 1 0 100-2h-1V7z" />
                  </svg>
                </button>
              </span>

              <AddContact showModal={showModal} handleClose={handleClose} />
            </div>
            <div className="flex mt-28 mr-8 "></div>
          </div>
        </div>
        {/* 
        <div className="flex flex-col">
          <div className="dark:bg-gray-900 overflow-y-auto">
            <div className="dark:bg-gray-900">
              <div className="dark:bg-gray-900 align-middle inline-block min-w-full shadow overflow-hidden sm:rounded-lg border-b border-gray-200">
                <table className="dark:bg-gray-900 min-w-full">
                  <thead>
                    <tr>
                      <th className="dark:bg-gray-600 dark:text-white w-12 px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        &nbsp;
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("Nom.contact.table")}
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("tel.contact.table")}e
                      </th>
                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        {t("adress.contact.table")}
                      </th>

                      <th className="dark:bg-gray-600 dark:text-white px-6 py-3 border-b border-gray-200 bg-gray-50 text-left text-xs leading-4 font-medium text-gray-500 uppercase tracking-wider">
                        Actions
                      </th>
                    </tr>
                  </thead>
                  <tbody className="bg-white">{collegues}</tbody>
                </table>
              </div>
            </div>
          </div>
          <div className="flex flex-wrap justify-center  mt-64">
            <ScaleLoader
              color="#109669"
              loading={loading}
              size={50}
              width={4}
              height={68}
            />
          </div>
        </div> */}
      </div>
    );
  }
}
export default withTranslation("common")(Contact);
